var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStroke(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 95,
    height: 100,
    viewBox: "0 0 95 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.6858 83.6468C47.2452 85.2914 40.9893 87.857 34.9452 90.3882C33.6457 90.9376 33.0056 92.4284 33.603 93.6631C34.1143 94.9487 35.6068 95.5326 36.8196 95.0333C42.6751 92.5753 48.7313 90.066 54.8785 88.5134C56.1918 88.1881 57.0188 86.8193 56.7012 85.4692C56.3841 84.12 54.9996 83.3224 53.6858 83.6468Z",
    fill: "#00CADD",
    stroke: "#00CADD",
    strokeWidth: 5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.7541 51.8957C43.5785 47.9429 28.9536 45.8118 14.8102 41.5148C13.5268 41.0918 12.1142 41.8451 11.7187 43.16C11.3236 44.4758 12.0294 45.8974 13.3994 46.2703C27.5583 50.5942 42.1981 52.7512 56.3892 56.7309C57.7472 57.0831 59.1395 56.2954 59.5216 54.9571C59.8175 53.6696 59.1121 52.2478 57.7541 51.8957Z",
    fill: "#00CADD",
    stroke: "#00CADD",
    strokeWidth: 5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.255 7.23235C57.5228 12.2924 60.7901 17.3527 64.0584 22.4135C64.7474 23.6069 66.3192 23.9281 67.4981 23.1701C68.6765 22.4112 68.9555 20.8956 68.266 19.7014C64.9932 14.6327 61.7214 9.5646 58.4491 4.49679C57.6735 3.35341 56.1056 3.03812 54.9307 3.80307C53.8424 4.51802 53.4799 6.08984 54.255 7.23235Z",
    fill: "#00CADD",
    stroke: "#00CADD",
    strokeWidth: 5
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStroke);
export default __webpack_public_path__ + "static/media/stroke.3821ac96378b403e029e211dc23381c1.svg";
export { ForwardRef as ReactComponent };